
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import CommonSection from "./Schedules/CommonSection.vue"
import Schedule1 from "./Schedules/Schedule1.vue"
import Schedule2 from "./Schedules/Schedule2.vue"
import Schedule3 from "./Schedules/Schedule3.vue"
import Schedule4 from "./Schedules/Schedule4.vue"
import Schedule5 from "./Schedules/Schedule5.vue"
import Schedule6 from "./Schedules/Schedule6.vue"
import Schedule7 from "./Schedules/Schedule7.vue"
import Schedule8 from "./Schedules/Schedule8.vue"
import Schedule9 from "./Schedules/Schedule9.vue"
import Schedule10 from "./Schedules/Schedule10.vue"
import Schedule11 from "./Schedules/Schedule11.vue"
import Schedule12 from "./Schedules/Schedule12.vue"

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

import moment from 'moment';

@Component({
    components:{
        
        CommonSection,
        Schedule1,
        Schedule2,
        Schedule3,
        Schedule4,
        Schedule5,
        Schedule6,
        Schedule7,
        Schedule8,
        Schedule9,
        Schedule10,
        Schedule11,
        Schedule12 
    }
})

export default class Form3 extends Vue {

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
    @applicationState.Action
    public UpdatePathwayCompleted!: (changedpathway) => void

    result;
    dataReady = false; 
    selectedSchedules: string[] = [];
   
    mounted(){
        this.dataReady = false;
        this.result = this.getFLMResultData();
        this.selectedSchedules = this.getSchedulesInfo();
        this.dataReady = true;
        Vue.nextTick(()=> this.onPrint())
    }   
           
    public onPrint() { 

        const pdf_type = Vue.filter('getPathwayPdfType')("familyLawMatter") 
        const pdf_name = "application-about-a-family-law-matter";    
        const el= document.getElementById("print");

        const applicationId = this.$store.state.Application.id;
        const bottomLeftText = `"PFA 712   `+moment().format("D/YYYY")+` \\a           Form 3";`;
        const bottomRightText = `" Application Family Law Matter | "`
        const url = '/survey-print/'+applicationId+'/?name=' + pdf_name + '&pdf_type='+pdf_type+'&version=1.0&noDownload=true'
        const pdfhtml = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText );

        const body = {
            'html':pdfhtml,
            'json_data':this.result
        }       
        
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }  

        this.$http.post(url,body, options)
        .then(res => {
            const currentDate = moment().format();
            this.$store.commit("Application/setLastPrinted", currentDate); 
            this.UpdatePathwayCompleted({pathway:"familyLawMatter", isCompleted:true})
            this.$emit('enableNext',true)                   
        },err => {
            console.error(err);        
        });
    }
 
    public getFLMResultData() {         
        
        let result = Object.assign({},this.$store.state.Application.steps[0].result); 

        for(const stepIndex of [this.stPgNo.COMMON._StepNo, this.stPgNo.FLM._StepNo]){
            const stepResults = this.$store.state.Application.steps[stepIndex].result
            for(const stepResultInx in stepResults){
                if(stepResults[stepResultInx])
                    result[stepResultInx]=stepResults[stepResultInx].data; 
            }
        }

        const childBestInterestAck = {childBestInterestAcknowledgement:this.$store.state.Application.steps[this.stPgNo.FLM._StepNo].result.childBestInterestAcknowledgement};
        Object.assign(result, result, childBestInterestAck);
        
        const applicationLocation = this.$store.state.Application.applicationLocation;
        const userLocation = this.$store.state.Common.userLocation;
       
        if(applicationLocation)
            Object.assign(result, result,{applicationLocation: applicationLocation}); 
        else
            Object.assign(result, result,{applicationLocation: userLocation});

        Vue.filter('extractRequiredDocuments')(result, 'familyLawMatter')

        return result;
    }

    public getSchedulesInfo(){       

        let schedules: string[] = [];
        const selectedFLMs = this.result.flmQuestionnaireSurvey;
        const flmBackgroundInfo = this.result.flmBackgroundSurvey;

        if (flmBackgroundInfo?.ExistingOrdersFLM == 'n') {
            
            if (selectedFLMs?.includes("parentingArrangements")){
                schedules.push("schedule1")
            }
            if (selectedFLMs?.includes("childSupport")){
                schedules.push("schedule3")
            }
            if (selectedFLMs?.includes("contactWithChild")){
                schedules.push("schedule5")
            }            
            if (selectedFLMs?.includes("spousalSupport")){
                schedules.push("schedule9")
            }
            if (selectedFLMs?.includes("companionAnimal")){
                schedules.push("schedule11")
            }

        } else if (flmBackgroundInfo?.ExistingOrdersFLM == 'y' && flmBackgroundInfo?.existingOrdersListFLM?.length > 0){

            if (selectedFLMs?.includes("parentingArrangements")) {

                if (flmBackgroundInfo.existingOrdersListFLM?.includes("Parenting Arrangements including `parental responsibilities` and `parenting time`")){                    
                    schedules.push("schedule2");
                } else {
                    schedules.push("schedule1");
                }
            }

            if (selectedFLMs?.includes("childSupport")){
                if (flmBackgroundInfo.existingOrdersListFLM?.includes("Child Support")){
                    schedules.push("schedule4");
                } else {
                    schedules.push("schedule3")
                }
            }

            if (selectedFLMs?.includes("contactWithChild")){
                if (flmBackgroundInfo.existingOrdersListFLM?.includes("Contact with a Child")){
                    schedules.push("schedule6")
                } else {
                    schedules.push("schedule5")
                }
            }

            if (selectedFLMs?.includes("spousalSupport")){
                if (flmBackgroundInfo.existingOrdersListFLM?.includes("Spousal Support")){
                    schedules.push("schedule10")
                } else {
                    schedules.push("schedule9");
                }
            } 

            if (selectedFLMs?.includes("companionAnimal")){
                if (flmBackgroundInfo.existingOrdersListFLM?.includes("Property Division in Respect of a Companion Animal")){
                    schedules.push("schedule12")
                } else {
                    schedules.push("schedule11");
                }
            } 
        }

        if (selectedFLMs.includes("guardianOfChild")){
            if (this.result.guardianOfChildSurvey){
                if (this.result.guardianOfChildSurvey?.applicationType?.includes('becomeGuardian')){
                    schedules.push("schedule7")
                }
                if (this.result.guardianOfChildSurvey?.applicationType?.includes('cancelGuardian')){
                    schedules.push("schedule8")
                }
            }            
        }        
        
        return schedules;
    }
}
